'use client';

import { toast } from '@/components/ui/use-toast';
import { getLogger } from '@/logger/logger';
import { getAuthSessionHint } from '@/storage/auth-session-hint.storage';
import { authStore, expireSession } from '@/store/auth.store';
import { setOpenSignInModal } from '@/store/modal';
import { LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import { setUnauthorizedHandler } from '@/utils/api/unauthorized-handler';

export const SESSION_EXPIRED_MESSAGE = 'Sua sessão expirou. Entre novamente para continuar de onde parou.';

const logger = getLogger('auth.session-expiry');

export function handleSessionExpired() {
  const { authenticatedUser, sessionExpired } = authStore.getState();

  if (sessionExpired) {
    return;
  }

  const wasInteracting = Boolean(authenticatedUser);
  const hadSession = wasInteracting || getAuthSessionHint();

  expireSession();

  if (!hadSession) {
    return;
  }

  logger.info('Session expired', {
    auth: { event: 'session_expired', prompted_login: wasInteracting },
  });

  toast({ variant: 'error', title: SESSION_EXPIRED_MESSAGE });

  if (wasInteracting) {
    setOpenSignInModal(true, { origin: LoginOriginEnum.SESSION_EXPIRED });
  }
}

export function registerSessionExpiryHandler() {
  setUnauthorizedHandler(handleSessionExpired);
}
